<!-- ========== Left Sidebar Start ========== -->
<div class="vertical-menu">
  <div class="sidebar-brand-shell">
    <button type="button" class="btn btn-sm font-size-16 header-item sidebar-menu-toggle" id="vertical-menu-btn"
      (click)="toggleMobileMenu($event)">
      <i class="fa fa-fw fa-bars"></i>
    </button>

    <div *ngIf="toggleLogo" class="sidebar-brand-logo">
      <span *ngIf="activeLogoSvg" class="sidebar-brand-logo__svg"
        [ngClass]="activeLogoCssClass" [innerHTML]="activeLogoSvg" [attr.aria-label]="titleLogoText"></span>
    </div>
  </div>

  <!--- Sidemenu -->
  <div id="sidebar-menu" class="sidebar-scroll">
    <!-- Left Menu Start -->
    <ul class="metismenu list-unstyled" id="side-menu">
      <ng-template #sidebarItemContent let-item>
        <span class="sidebar-menu-icon" *ngIf="item.icon || item.faIcon">
          <i-feather *ngIf="item.icon" name="{{ item.icon }}"></i-feather>
          <i *ngIf="item.faIcon" class="fa-icon {{item.faIcon}}"></i>
        </span>
        <span class="navlabel">{{ item.label | translate }}</span>
        <span class="badge rounded-pill bg-{{item.badge.variant}} float-end" *ngIf="item.badge">{{item.badge.text | translate}}</span>
      </ng-template>

      <ng-container *ngFor="let item of menuItems">
        <li class="menu-title" *ngIf="item.isTitle">{{ (item.label | translate) | uppercase }}</li>
        <li *ngIf="!item.isTitle && !item.isLayout" class="sidebar-menu-item sidebar-menu-item--curved">
          <a *ngIf="item.link && !hasItems(item) && !item.openOnNewPage"
            class="side-nav-link-ref"
            [routerLink]="item.link"
            [ngbTooltip]="item.label | translate" [disableTooltip]="!isSidebarCollapsed()" tooltipClass="sidebar-hover-tooltip" container="body" placement="bottom" [openDelay]="0" [closeDelay]="0">
            <ng-container [ngTemplateOutlet]="sidebarItemContent" [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
          </a>
          <a *ngIf="item.link && !hasItems(item) && item.openOnNewPage"
            class="side-nav-link-ref"
            [attr.href]="item.link"
            target="_blank"
            rel="noopener noreferrer"
            [ngbTooltip]="item.label | translate" [disableTooltip]="!isSidebarCollapsed()" tooltipClass="sidebar-hover-tooltip" container="body" placement="bottom" [openDelay]="0" [closeDelay]="0">
            <ng-container [ngTemplateOutlet]="sidebarItemContent" [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
          </a>
          <a href="" (click)="$event.preventDefault(); menuClicked(item.name)" *ngIf="!item.link" class="side-nav-link-ref side-nav-action-link"
            [ngbTooltip]="item.label | translate" [disableTooltip]="!isSidebarCollapsed()" tooltipClass="sidebar-hover-tooltip" container="body" placement="bottom" [openDelay]="0" [closeDelay]="0"
            [target]="item.openOnNewPage ? '_blank': '_self'">
            <ng-container [ngTemplateOutlet]="sidebarItemContent" [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
          </a>
        </li>
      </ng-container>
      <div id="contact-us" style="text-align: center;margin-bottom: 40px;">
        {{ 'SIDEBAR.NEED_HELP' | translate }}<br>
        <a target="_blank" href="https://reach.marketing/reach-feedback-form/">{{ 'SIDEBAR.CONTACT_US' | translate }}</a>
      </div>
    </ul>
    <!--
    <div *ngIf="hasSpecialRoles()" class="alert alert-dark info-text">
      Subscriptions, Orders, Users & Payment Methods can be found under My Account
    </div>
    -->
  </div>
  
  <!-- Sidebar -->
</div>
<!-- Left Sidebar End -->